const METHOD = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    PATCH: 'PATCH',
    DELETE: 'DELETE'
};

const CONTENT_TYPE_APP_JSON = 'application/json';

const HEADER = {
    X_AUTH_TOKEN: 'X-Auth-Token',
    CONTENT_TYPE: 'Content-Type',

    AUTHORIZATION: 'Authorization',
    ACCEPT: 'Accept'
};

// Api routes
const parsedAppConfig = JSON.parse(process.env.APP_CONFIG);
const REST_HOST = parsedAppConfig.REACT_APP_BE_API_URL;
const STORM_HOST = parsedAppConfig.REACT_APP_STORM_API_URL;
const LANDING_HOST = parsedAppConfig.REACT_APP_LANDING_URL;

const API_URL = REST_HOST;

// Keycloak appkey
const KEYCLOAK_STORAGE_KEY = 'keysec';

const REQUEST_URL = {
    AUTH_LOGIN: `/auth/login`,
    HOMES_LIST: '/home',
    HOME: '/home',
    HOME_ID: '/home/:homeId',
    HOME_UNDELETE_ID: '/home/undelete/:homeId',
    HOME_DETAIL: '/home/:homeId/detail',
    HOME_DETAIL_USERS: '/home/:homeId/users',
    HOME_DETAIL_METER: '/home/:homeId/meter',
    HOME_DETAIL_METER_DEVICE: '/home/:homeId/meter/:meterId/device',
    HOME_DETAIL_METER_SWITCH: '/home/:homeId/meter/:meterId/switch',
    HOME_DETAIL_INVITE_RESIDENT: '/home/:homeId/invite-resident',
    HOME_DETAIL_INVITED_USERS: '/invitation/:homeId',
    HOME_DETAIL_USER_ID: '/home/:homeId/delete-resident/:residentId',
    HOME_IMPORT_CSV: '/home/:homeId/loadProfile',
    USERS: `/users`,
    USER: `/user`,
    USER_ID: `/user/:userId`,
    USER_CHANGE_PASSWORD: `/user/:userId/changepassword`,
    USER_ID_UNDELETE: `/user/undelete/:userId`,
    USER_ADMIN: `/user/admin`,
    USER_FILTER: `/user/filter`,
    METER: '/meter',
    METER_TYPES: '/meter/types',
    METER_PURPOSES: '/meter/:meterId/purposes',
    METER_FLAVORS: '/meter/modbusFlavors',
    METER_LIST: '/meter/:homeId',
    METER_ID: '/meter/:meterId',
    WA_PI_PROPS: '/meter/:meterId/properties',
    METER_MQTT_ACCESS_API: '/meter/:meterId/mqttAccessApi',
    LATEST_MESSAGE: '/meter/:meterId/latestMessage',
    METER_STATUS: '/meter/:meterId/connectionStatus',
    METER_SUPPORT_GET: '/meter/:meterId/metersupport/status',
    METER_SUPPORT: '/meter/:meterId/metersupport/',
    MESSAGES: '/meter/:meterId/message',
    KWH_BY_METER_ID: '/recognition/meter/:meterId/kwh',
    METER_ID_UNDELETE: '/meter/undelete/:meterId',
    DEVICE_ID: '/device/:deviceId',
    DEVICE_ID_UNDELETE: '/device/undelete/:deviceId',
    DEVICE_FOR_METER_ID: '/device/meter/:meterId',
    DEVICE_CONSUMPTION_FOR_METER_ID: '/device/meter/consumption/:meterId',
    DEVICE_MERGE: '/device/merge/:oldDeviceId/into/:newDeviceId',
    INVITATION_PROCESS: '/invitation/:invitationHashId',
    INVITATION_OWNER_PROCESS: '/invitation/owner/:invitationHashId',
    INVITATION_ID: '/invitation/:invitationId',
    SETTINGS: '/settings',
    SMART_PI: '/smartpi/:devId',
    SMART_PI_SOLAR: '/smartpi/:devId/solar',
    DEVICE_TYPES_LIST: '/devicetype/all',
    RAW_DATA: '/power/meter/:meterIds/bydepth/full',
    CSV_REPORT: '/power/meter/:meterId/csv',
    EXCEL_REPORT: '/power/meter/:meterIds/excel',
    DEVICE_LIST: '/device?meter=:meterId',
    HISTORICAL_POWER_USAGE: '/straining/:meterId',
    HISTORICAL_POWER_USAGE_FOR_DEVICE: '/straining/device/:deviceId',
    DEVICE_ASSISTANT: '/straining/assistant/:meterId',
    POWER_USAGE_HINT: '/power_usage/hint',
    SAVING_POTENTIALS_BY_METER_ID: '/recognition/saving/meter/:meterId',
    SWITCH_LIST: '/switch/:meterId',
    SWITCH_POST: '/switch/:switchId',
    SWITCH_UPDATE: '/switch/:meterId/:switchId',
    SWITCH_UNDELETE_ID: '/switch/undelete/:switchId',
    SWITCH_RELAY_TYPES: '/switch/relayTypes',
    SWITCH_STATUS: '/switch/:meterId/connectionStatus',
};

export { METHOD, REQUEST_URL, API_URL, CONTENT_TYPE_APP_JSON, KEYCLOAK_STORAGE_KEY, HEADER, STORM_HOST, LANDING_HOST };
